const defaultOptions: SortOptions[] = [
  'popular',
  'name',
  'volatility',
  'hitRatio',
  'rtp',
];

const liveRtpOptions: SortOptions[] = [
  'popular',
  'rtpLivePastDay',
  'rtpLivePastSevenDays',
  'rtpLivePastThirtyDays',
];

const getSortOptions = (isLiveRtp?: boolean) => {
  if (isLiveRtp) {
    return liveRtpOptions;
  }
  return defaultOptions;
};

export default getSortOptions;
